import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { DashboardComponent } from './dashboard';
import { NoContentComponent, UnAuthorizeComponent, ErrorComponent } from './shared/helper-components';
import { roleGuard, authGuard, pendingChangesGuard } from './shared/core/index';
import { UserManagementComponent } from './users/user-management.component';
import { SearchComponent } from './search/search.component';
import { ClearanceItemComponent, ClearanceListComponent } from './clearance-item';
import { ClearanceItemHistoryComponent } from './clearance-item/clearance-item-history.component';

import { DocumentDetailComponent } from './docviewer/document-detail.component';

export const ROUTES: Routes = [
  
  { path: '', component: DashboardComponent, pathMatch: 'full', canActivate: [roleGuard], data: { roles: [environment.clearanceRole, environment.productionRole] } }, 
  { path: 'access_token', redirectTo: '/dashboard', pathMatch: 'full' }, 
  { path: 'docviewer/:filename/:originalname/:projectId/:ciId/:assetType/:imageIndex/:from/:query',
    component: DocumentDetailComponent,
    canActivate: [roleGuard],
    canDeactivate: [pendingChangesGuard],
    data: { roles: [environment.clearanceRole, environment.productionRole] } },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [roleGuard], data: { roles: [environment.clearanceRole, environment.productionRole] },
  },
  {
    path: 'dashboard/:projectId',
    component: DashboardComponent,
    canActivate: [roleGuard], data: { roles: [environment.clearanceRole, environment.productionRole] },
  },
  {
    path: 'usermanagement',
    component: UserManagementComponent,
    canActivate: [roleGuard], data: { roles: [environment.clearanceRole] },
    canDeactivate: [pendingChangesGuard]
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [roleGuard],
    data: {
      roles: [environment.clearanceRole, environment.productionRole],
      key: 'search'
    }
  },
  // {
  //   path: 'search/:projectId/items/:ciId',
  //   component: ClearanceItemComponent,
  //   canActivate: [roleGuard], data: {
  //     roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE]
  //   },
  //   canDeactivate: [pendingChangesGuard]
  // },
  // {
  //   path: 'search/:projectId/items/:ciId/history',
  //   component: ClearanceItemHistoryComponent,
  //   canActivate: [roleGuard], data: {
  //     roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE]
  //   },
  // },
  { path: '401', component: UnAuthorizeComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: NoContentComponent },
];
